var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2166 9.82049C11.8337 7.5158 9.78612 5.08811 8.75 4.08008H5.25C4.21387 5.08811 2.16627 7.5158 1.78341 9.82049C1.49854 11.5353 3.07957 12.8348 4.84652 12.8348H9.15349C10.9204 12.8348 12.5015 11.5353 12.2166 9.82049Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26179 4.11089L4.0877 2.05743C4.08527 2.05318 4.08882 2.04801 4.09365 2.04876L5.83753 2.31906L7.00397 1.1677C7.00624 1.16543 7.00998 1.16546 7.01219 1.16775L8.14993 2.31906L9.8938 2.04875C9.89864 2.04801 9.9022 2.05316 9.89981 2.0574L8.73518 4.11089",
    stroke: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagIcon);
export default __webpack_public_path__ + "static/media/money-bag-icon.f7e55a3449dc544e6823f8b4896a855c.svg";
export { ForwardRef as ReactComponent };